import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const LocationOpeningTimes = lazy(() => import(/* webpackChunkName: "LocationOpeningTimes" */ './components/LocationOpeningTimes'));

const OpenTill = lazy(() => import(/* webpackChunkName: "OpenTill" */ './components/OpenTill'));

const ReachableTimes = lazy(() => import(/* webpackChunkName: "ReachableTimes" */ './components/ReachableTimes'));

const locationOpeningTimes = Array.from(document.querySelectorAll('[data-location-opening-times]'));
if (locationOpeningTimes != null) {
    locationOpeningTimes.forEach(element => {
        const props = parseDatasetToProps(element.dataset);

        render(
            <Suspense fallback={<></>}>
                <LocationOpeningTimes
                    {...props}
                />
            </Suspense>,
            element
        );
    })
}

const openTillElements = Array.from(document.querySelectorAll('[data-location-open-till]'));
if (openTillElements != null) {
    openTillElements.forEach(element => {
        const props = parseDatasetToProps(element.dataset);

        render(
            <Suspense fallback={<></>}>
                <OpenTill
                    {...props}
                />
            </Suspense>,
            element
        );
    })
}

const reachableTimesElements = Array.from(document.querySelectorAll('[data-location-reachable-times]'));
if (reachableTimesElements != null) {
    reachableTimesElements.forEach(element => {
        const props = parseDatasetToProps(element.dataset);

        render(
            <Suspense fallback={<></>}>
                <ReachableTimes
                    {...props}
                />
            </Suspense>,
            element
        );
    })
}

const todayIndex = new Date().getDay();
const days = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
const today = days[todayIndex];

document.querySelectorAll('.list--opening-times [data-day]').forEach(element => {
    if (element.dataset.day === today) {
        element.classList.add('is-today');

        const openTillElement = element.closest('.vdp-opening-times')?.querySelector('[data-location-open-till]');
        if (openTillElement?.dataset.times) {
            try {
                const times = JSON.parse(openTillElement.dataset.times);
                const todayTimes = times[today];
                if (!todayTimes?.from || !todayTimes?.till) {
                    element.classList.add('is-closed');
                } else {
                    const now = new Date();
                    const currentMinutes = now.getHours() * 60 + now.getMinutes();
                    const [fromHours, fromMins] = todayTimes.from.split(':').map(Number);
                    const [tillHours, tillMins] = todayTimes.till.split(':').map(Number);
                    const fromMinutes = fromHours * 60 + fromMins;
                    const tillMinutes = tillHours * 60 + tillMins;

                    if (currentMinutes < fromMinutes || currentMinutes >= tillMinutes) {
                        element.classList.add('is-closed');
                    }
                }
            } catch (e) {}
        }
    }
});
